import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import creditImg from '../assets/images/atm-card.png';
import dthImg from '../assets/images/online.png';
import electricalImg from '../assets/images/electrical-energy.png';
import tollImg from '../assets/images/toll.png';
import telephoneImg from '../assets/images/telephone.png';
import lifeInsuranceImg from '../assets/images/healthcare.png';
import loanRepaymentImg from '../assets/images/borrowing.png';
import lpgImg from '../assets/images/lpg.png';
import mobileImg from '../assets/images/user-interface.png';
import gasImg from '../assets/images/gas-meter.png';
import tapImg from '../assets/images/water-tap.png';

const BillPay = () => {
  const { Text } = Typography;
  const navigate = useNavigate();

  const [selectedCard, setSelectedCard] = useState();
  const outletRef = useRef(null);
  const location = useLocation();

  const services = [
    // { img: creditImg, label: "Credit Card", route: 'credit-card' },
    { img: dthImg, label: "DTH Recharge", route: 'dth' },
    { img: electricalImg, label: "Electricity", route: 'electricity' },
    { img: tollImg, label: "Fastag", route: 'fastag' },
    { img: telephoneImg, label: "Landline Postpaid", route: 'landline-postpaid' },
    { img: lifeInsuranceImg, label: "Life Insurance", route: 'life-insurance' },
    { img: loanRepaymentImg, label: "Loan Repayment", route: 'loan' },
    { img: lpgImg, label: "LPG Gas", route: 'lpg-gas' },
    { img: mobileImg, label: "Mobile Postpaid", route: 'mobile-postpaid' },
    { img: gasImg, label: "Piped Gas", route: 'piped-gas' },
    { img: tapImg, label: "Water", route: 'water' },
  ];

  const handleCardClick = (e,route) => {
    e.preventDefault();
    setSelectedCard(route);
    navigate(`/user/bill-pay/${route}`);
  };

  useEffect(() => {
    if (outletRef.current) {
      outletRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [location]);

  return (
    <div className="layout-content">
      <Row className="main-services mb-25" gutter={[16, 16]}>
        {services.map((service, index) => (
          <Col key={index} className="service-col" xs={12} sm={8} md={6} lg={6} xl={4}>
            <Card
              className={`service-card ${selectedCard === service.route ? 'selected' : ''}`}
              hoverable
              aria-label={service.label}
              onClick={(e) => handleCardClick(e, service.route)}
            >
              <div className="icon-wrapper">
                <img
                  src={service.img}
                  alt={service.label}
                  className="service-icon"
                />
              </div>
              <Text className="service-text">{service.label}</Text>
            </Card>
          </Col>
        ))}
      </Row>
      <div ref={outletRef}>
        <Outlet />
      </div>
    </div>
  )
}

export default BillPay